import { ORGANISATION_LIST_QUERY } from "@/graphql/organisations/queries/organisation";
import { useQuery } from "@apollo/client";

export default function useAvailableOrganisations() {
  const {
    data: { organisations: availableOrganisations } = {},
    loading,
    refetch
  } = useQuery(ORGANISATION_LIST_QUERY);

  return [availableOrganisations, { loading, refetch }];
}
